import React, { useEffect, useMemo, useState } from 'react';
// Enums
import ENUMS from '../../../../../enums';
// Styles
import './style.scss';

export default function ListItem({
  multiReservesId,
  table,
  onDetailClick,
  onInvoiceClick,
  onChangeTableStatusClick,
  timeId,
  fromTime,
  toTime,
  discountCodeType,
  discountCodeAmount,
  cafeDiscountPercent,
}) {
  const [multiTable, setMultiTable] = useState({});

  const isStatusFinished = useMemo(
    () => table.status === ENUMS.CAFE_RESERVATION.values.FINISHED,
    [table.status],
  );

  const isStatusStart = useMemo(
    () => table.status === ENUMS.CAFE_RESERVATION.values.STARTED,
    [table.status],
  );

  const clientDoNotCome = useMemo(
    () => table.status === ENUMS.CAFE_RESERVATION.values.CLIENT_DO_NOT_CAME,
    [table.status],
  );

  const cssClass = useMemo(
    () =>
      `schematic-table-number-container cursorPointer ${ENUMS.SHEMATIC_RESERVATION.tableColors[table.status]
      } ${ENUMS.SHEMATIC_RESERVATION.tableTimeStatus[table.tableTimeStatus]} rounded-lg`,
    [],
  );

  const customStyle = useMemo(
    () =>
      !(isStatusFinished || clientDoNotCome)
        ? {
          backgroundColor: multiTable.backgroundColor,
          color: multiTable.color,
        }
        : null,
    [isStatusFinished, clientDoNotCome, multiTable],
  );

  useEffect(() => {
    const foundSimilar = multiReservesId.find(
      item => item.id == table.reserveId,
    );
    if (foundSimilar) {
      setMultiTable(foundSimilar);
    }
  }, [multiReservesId]);

  const handleOnDetailClick = event => {
    event.preventDefault();
    event.stopPropagation();
    if (table.reserveId) {
      onDetailClick(table.reserveId);
    }
    if (table.tableTimeStatus !== 'RESERVED' && table.reserveId === null) {
      onChangeTableStatusClick(
        timeId,
        fromTime,
        toTime,
        table,
      );
    }
  };

  // const handleOnInvoiceClick = event => {
  //   event.preventDefault();
  //   event.stopPropagation();
  //   if (table.reserveId) {
  //     onInvoiceClick(table.reserveId);
  //   }
  // };

  return (
    <div className='d-flex flex-column align-items-center'>
      <div className='px-1 mb-1 bg-danger text-white'>
        <span>
          {discountCodeType !== undefined && discountCodeType === 'VALUE' &&
            <span>{`تومان ${discountCodeAmount}`}</span>
          }
          {discountCodeType !== undefined && discountCodeType === 'PERCENT' &&
            <span>{`% ${discountCodeAmount}`}</span>
          }
        </span>
      </div>
      <div
        className={cssClass}
        onClick={event => handleOnDetailClick(event)}
        style={customStyle}
      >
        {/* {table.reserveId && (
        <span
          title={locales('titles.editIncomingReservation')}
          onClick={handleOnDetailClick}
          className='text-center pointer shematic-detail'
        >
          <i className='text-center far fa-info-circle pointer' />
        </span>
      )} */}
        {/*  Note : use classes for css and do not use inline css*/}
        <span className={table.num.length > 2 ? 'longText' : ''}>
          {table.num}
        </span>

        {/* {table.reserveId && (isStatusStart || isStatusFinished) && (
        <span
          title={locales('titles.seeAndEditIncomingReserveFactor')}
          onClick={handleOnInvoiceClick}
          className='text-center pointer mx-1 shematic-invoice'
        >
          <i className='text-center far fa-usd-circle pointer' />
        </span>
      )} */}
      </div>

      {/* {cafeDiscountPercent !== undefined && cafeDiscountPercent !== null &&
        <div className='p-1 my-1 bg-secondary text-white rounded'>{`% ${cafeDiscountPercent}`}</div>
      } */}
      {cafeDiscountPercent !== undefined && cafeDiscountPercent !== null &&
        <div className='p-1 my-1 bg-secondary text-white rounded'>{`%`}</div>
      }
    </div>
  );
}
